import type { StoreState } from '../../state-types';
import { pathOr } from '../utils/path-or';
import { getCardNextIndexCardId } from './get-card-next-index-card-id';

export const getCardComputedResultCardId =
    (cardId: string) =>
    (state: StoreState): string | undefined => {
        const resultCardId = pathOr<string | undefined>(
            state,
            ['cards', cardId, 'resultCard'],
            undefined
        );
        const nextCardId = getCardNextIndexCardId(cardId)(state);

        // when result card not found, fallbacks to the next card
        return resultCardId || nextCardId;
    };
